import React, { Component } from 'react';
import { Link } from 'react-router-dom';

const liff = window.liff;

export class Booking extends Component {
    static displayName = Booking.name;

    constructor(props) {
        super(props);

        this.state = {
            jpage: "",
            storeName: "",
            bookinglist: []
        };
    }

    componentDidMount() {
        this.populateProfile();
    }

    closeLIFF() {
        liff.closeWindow();
    }

    async populateProfile() {
        if (!liff.isInClient()) {
            this.props.history.push('/NotInLine');

            //let LineuserId = "U3189d053eaa99d5015d7cc4a4cd14f87";
            //let LineuserPicture = "";                        
        } else {
            liff.init({
                liffId: '1661485377-z2p58Y1Z'
            }).then(async () => {
                let LineuserId = "";
                let LineuserPicture = "";

                await liff.getProfile()
                    .then(profile => {
                        LineuserId = profile.userId;
                        LineuserPicture = profile.pictureUrl;
                    })
                    .catch((err) => {
                        LineuserId = "Err";
                    });

                if (LineuserId === "Err") {
                    this.props.history.push('/MistakeLine')
                }
                else {
                    //action - start
                    //check Partners exists or not - start
                    const requestOptions = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(
                            {
                                UserId: LineuserId
                            }
                        )
                    };

                    await fetch('/api/partnercheck', requestOptions)
                        .then(response => response.json())
                        .then(json => {
                            if (json.responsecode === "Approve") {
                                //Partners exists and already approve-> Show This page
                                this.setState({
                                    userLineID: LineuserId,
                                    storeName: json.storeName
                                });

                            }
                            else {
                                //Partners not exists or not approve -> Show Home page
                                this.props.history.push('/')
                            }
                        });
                    //check Partners exists or not - end

                    //retrive upcoming booking list - start
                    const requestOptions2 = {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(
                            {
                                UserId: LineuserId
                            }
                        )
                    };

                    await fetch('/api/bookinglisttoday', requestOptions2)
                        .then(response => response.json())
                        .then(json => {
                            this.setState({
                                bookinglist: json
                            });
                        });
                    //retrive upcoming booking list  - end

                    this.setState({
                        jpage: 'done'
                    });
                    //action - end
                }
            });
        }
    }

    render() {
        if (this.state.jpage === "done") {
            var storeName = this.state.storeName;

            //upcoming booking today - start
            var bookinglist = [];
            var totallist = this.state.bookinglist.length;
            var cssbutton01 = "";
            var thisbookmobile = "";
            var thislink = "";
            var bookstatus = "";
            for (let i = 0; i < this.state.bookinglist.length; i++) {
                switch (this.state.bookinglist[i].status) {
                    case "Confirmed": cssbutton01 = "btn btn-sm mt-2 mb-0 btn-register-2"; thislink = "/BookingDetail"; bookstatus = "Confirmed"; break;
                    case "Check-in": cssbutton01 = "btn btn-sm mt-2 mb-0 btn-register-4"; thislink = "/BookingCheckIn"; bookstatus = "Checked-in"; break;
                    case "Cancel": cssbutton01 = "btn btn-sm mt-2 mb-0 btn-register-cancelled"; thislink = "/BookingDetail"; bookstatus = "Cancelled"; break;
                    case "Completed": cssbutton01 = "btn btn-sm mt-2 mb-0 btn-register-completed"; thislink = "/BookingDetail"; bookstatus = "Completed"; break;
                    default: cssbutton01 = "btn btn-sm mt-2 mb-0 btn-register-completed"; thislink = "/BookingDetail"; bookstatus = this.state.bookinglist[i].status; break;
                }

                thisbookmobile = "tel:" + this.state.bookinglist[i].mobile;

                bookinglist.push(
                    <div className="col-12 mb-2" key={i}>
                        <div className="card card-room-list">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-8"><div className="head-room-name">{this.state.bookinglist[i].firstname}</div></div>
                                    <div className="col-4 text-end lh-1"><span className="booking-no">Booking No.</span><br /><span className="booking-number">{this.state.bookinglist[i].bookingRefNo}</span></div>
                                </div>
                                <div className="row row-room-detail">
                                    <div className="col-8 p-0 ps-2">
                                        <div><span className="room-detail"><img src={require("./media/Icon feather-phone.png")} alt="Time" className="ms-1" /> <Link to={{ pathname: thisbookmobile }} target="_blank" className="fontsodo-semibold text-black">{this.state.bookinglist[i].mobile}</Link></span></div>
                                        <div><span className="room-detail"><img src={require("./media/icon-meeting.png")} alt="Room" className="ms-1" /> {this.state.bookinglist[i].roomName} for {this.state.bookinglist[i].roomMaxGuest}</span></div>
                                        <div><span className="room-text-detail"><img src={require("./media/Icon-feather-calendar.png")} alt="Date" className="ms-1" /> {this.state.bookinglist[i].dateStartTxt}</span></div>
                                        <div><img src={require("./media/Icon-feather-clock.png")} alt="Time" className="ms-2" /> <span className="room-text-detail">{this.state.bookinglist[i].timeStart} - {this.state.bookinglist[i].timeEnd}</span></div>
                                        <div><span class="room-text-detail">Total Attandee : {this.state.bookinglist[i].totalMan} People</span></div>
                                        <div><span class="room-text-detail">Total Cost	: {this.state.bookinglist[i].totalPrice} Baht</span></div>
                                    </div>
                                    <div className="col-4 text-end align-self-end">
                                        <Link to={{
                                            pathname: thislink,
                                            state: {
                                                bookingrunid: this.state.bookinglist[i].bookingRunId
                                            }
                                        }} className={cssbutton01} >
                                            {bookstatus}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                )
            }
            //upcoming booking today - end

        }
        return (
            <div className="form-signin shadow bg-home position-relative">
                <div className="head-nav p-0">
                    <img src={require("./media/stb_partner.png")} alt="SBUX Partner Portal" className="img-fluid mt-0 mb-0" />
                </div>
                {
                    (this.state.userLineID && this.state.userLineID !== '')
                        ?
                        <>
                            <div className="form-enter pt-0 mt-4">
                                <div className="row p-3 pb-0">
                                    <div className="col-2"><p className="fontsodo-semibold mb-0">Store</p></div>
                                    <div className="col-10"><p className="fontsodo-semibold text-green mb-0">{storeName}</p></div>
                                </div>
                                <h2 className="h4 text-center pt-0 mb-0 fontsodo-bold">Booking Status</h2>
                                <div className="row p-3 pb-2">
                                    <div className="col-4 p-1">
                                        <Link to="/Booking" className="btn btn-outline-darkgreen"> <span className="float-start">Today</span> <span className="badge badge-white text-bg-secondary float-end">{totallist}</span></Link>
                                    </div>
                                    <div className="col-4 p-1">
                                        <Link to="/BookingUpcoming" className="btn btn-outline-white"> <span className="float-start">Upcoming</span></Link>
                                    </div>
                                    <div className="col-4 p-1">
                                        <Link to="/BookingPast" className="btn btn-outline-white"> <span className="float-start">History</span></Link>
                                    </div>
                                </div>

                                <div className="row p-2 pt-0 pe-0 row-card-room-list-2">
                                    {bookinglist}
                                </div>
                            </div>
                            <div className="box-footer-button position-relative mt-2">
                                <div className="row text-center mt-3 mb-0 justify-content-center">
                                    <div className="col-6 p-0">
                                        <div className="d-grid">
                                            <Link to="/" className="btn btn-lg mb-0 btn-register-3">Back</Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                        :
                        <>
                            <div className="form-enter mt-1 pb-0">
                                <form>
                                    <div className="text-center" style={{ height: '160px' }} />
                                    <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                        <h3 className="text-white">LOADING ...</h3>
                                        <img src={require("./media/loading-gif.gif")} alt="Loading..." width={80} className="img-fluid" />
                                    </div>
                                    <div style={{ height: '100px' }} />
                                </form>
                            </div>
                        </>
                }
            </div>
        );
    }
}
